export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pyodide.worker.a3b7f9aa.js");
}
